<template>
	<div class="contact-information form-group-shipping">
		<div class="contact-information-header section-title">
			<span :style="getStyle(node)">Pengiriman:</span>
		</div>
		<div class="form-group" data-select2-id="161">
			<div class="row">
				<!-- courier -->
				<div class="col-sm-6">
					<div class="form-group">
						<multiselect
							:options="[]"
							:searchable="true"
							:close-on-select="true"
							:show-labels="false"
							track-by="name"
							label="name"
							placeholder="Pilih Kurir">
							<span slot="noResult">Kurir tidak ditemukan</span>
						</multiselect>
					</div>
				</div>

				<!-- service -->
				<div class="col-sm-6">
					<div class="form-group">
						<multiselect
							:options="[]"
							:searchable="true"
							:close-on-select="true"
							:show-labels="false"
							track-by="name"
							label="name"
							placeholder="Pilih Paket">
							<span slot="noResult">Service tidak ditemukan</span>
						</multiselect>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import { getNodeStyle } from '@/lib/helper';

export default {
	name: 'FormShipment',
	props: {
		node: Object,
		product: {
			type: Object,
			default: null,
		},
		origin: {
			type: Object,
			default: null,
		},
		availableCouriers: {
			type: Array,
			default: () => [],
		},
		availableServices: {
			type: Array,
			default: () => [],
		},
		destination: {
			type: Object,
			default: null,
		},
		weight: {
			type: Number,
			default: 0,
		},
		selectedCourier: {
			type: Object,
			default: null,
		},
		selectedService: {
			type: Object,
			default: null,
		},
		selectedPayment: {
			type: Object,
			default: null,
		},
		multipleVariation: {
			type: Array,
			default: () => [],
		},
		isMultipleVariant: {
			type: Boolean,
			default: false,
		},
		productType: {
			type: String,
			default: 'simple',
		},
		contact: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {};
	},
	computed: {},
	watch: {},
	created() {},
	methods: {
		getStyle({ options }) {
			const styles = [
				'text-color',
			];
			const style = getNodeStyle(options, styles);
			return style;
		},
	},
};
</script>

<style class="scss" scoped>
.text-small {
	font-size: 10px;
}

</style>
